import React from 'react';
import PropTypes from 'prop-types';

import strings from 'utils/strings';
import handBookPdf from 'assets/DysmateHåndbok_v1.1_compressed.pdf';
import dysmate2HandBookPdf from 'assets/Dysmate2_compressed.pdf';

const INTRO_KEYS_BY_TYPE = {
	'child-screening': 'reportIntroductionChildScreening',
	'youth-screening': 'reportIntroductionYouthScreening',
	'adult-screening': 'reportIntroductionAdultScreening',

	'child-followup': 'reportIntroductionChildFollowup',
	'youth-followup': 'reportIntroductionYouthFollowup',
	'adult-followup': 'reportIntroductionAdultFollowup',
};

const getNorwegianPossessiveName = (name) => {
	if (!name) {
		return '';
	}

	const trimmedName = name.trim();

	if (/[sxz]$/i.test(trimmedName)) {
		return `${trimmedName}'`;
	}

	return `${trimmedName}s`;
};

const ReportIntroduction = ({
	testType,
	testResult,
	testReportLang,
	useDysmate2Handbook,
}) => {
	const localizedStrings =
		testReportLang === 'nn' ? strings._props.nn : strings;

	const introductionKey = INTRO_KEYS_BY_TYPE[testType];

	if (!introductionKey || !localizedStrings[introductionKey]) {
		return null;
	}

	const firstName = testResult?.testUser?.firstName;
	const isChild =
		testType === 'child-screening' || testType === 'child-followup';
	const isFollowup = testType.includes('followup');
	console.log('isFollowup ', isFollowup, ' testType ', testType);
	const mainHeading = !isFollowup
		? localizedStrings.reportIntroductionHeading
		: localizedStrings.reportIntroductionHeadingFollowup;
	const namedPossessive = firstName
		? getNorwegianPossessiveName(firstName)
		: null;

	const pluralPossessive = namedPossessive
		? namedPossessive
		: testReportLang === 'nn'
			? isChild
				? 'eleven sine'
				: 'kandidaten sine'
			: isChild
				? 'elevens'
				: 'kandidatens';

	const singularPossessive = namedPossessive
		? namedPossessive
		: testReportLang === 'nn'
			? isChild
				? 'eleven si'
				: 'kandidaten si'
			: isChild
				? 'elevens'
				: 'kandidatens';

	const paragraphs = localizedStrings[introductionKey]
		.split('\n\n')
		.map((paragraph) =>
			strings.formatString(
				paragraph,
				pluralPossessive,
				singularPossessive
			)
		);

	return (
		<div className="report-introduction">
			<h3 className="report-introduction__heading">{mainHeading}</h3>
			{paragraphs.map((paragraph, index) => (
				<p key={index}>{paragraph}</p>
			))}

			<p>
				{localizedStrings.reportIntroductionHandbookPrefix}{' '}
				<a
					href={
						useDysmate2Handbook ? dysmate2HandBookPdf : handBookPdf
					}
					target="_blank"
					rel="noopener noreferrer"
				>
					{localizedStrings.reportIntroductionHandbookLinkText}
				</a>
				.
			</p>
		</div>
	);
};

ReportIntroduction.propTypes = {
	testType: PropTypes.string.isRequired,
	testResult: PropTypes.shape({
		testUser: PropTypes.shape({
			firstName: PropTypes.string,
		}),
	}).isRequired,
	testReportLang: PropTypes.string,
	useDysmate2Handbook: PropTypes.bool,
};

ReportIntroduction.defaultProps = {
	testReportLang: 'no',
	useDysmate2Handbook: false,
};

export default ReportIntroduction;
